import React from "react";

import Breadcrumb from "../components/Breadcrumb";
import ErrorLayer from "../components/ErrorLayer";


const ErrorPage = () => {
  return (
    <>
      

        {/* ErrorLayer */}
        <ErrorLayer />


      
    </>
  );
};

export default ErrorPage;
